module.exports = __webpack_public_path__ + "img/image28.579e8a66.webp";